export default __webpack_public_path__ + "atomic/_patterns/02-molecules/hero-image/_hero-image.twig";